import { cn } from '@/lib/utils'

/** Viral's mark: a V whose rising stroke carries on as a dot leaving the
 *  frame — a post going out. The square takes the text colour, so it is dark
 *  on the light theme and light on the dark one; the dot is one fixed blue
 *  that holds against both. `public/favicon.svg` is the same drawing. */
export function BrandMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      className={cn('shrink-0', className)}
    >
      <rect width="24" height="24" rx="6.5" className="fill-foreground" />
      <path
        d="M6.4 8.6 10.9 16.6 15.4 8.2"
        fill="none"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-background"
      />
      <circle cx="18" cy="5.6" r="1.75" fill="#3D6BFF" />
    </svg>
  )
}

/** Mark and name together: the sidebar head and the sign-in page. */
export function Wordmark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <BrandMark size={size} />
      <span className="flex min-w-0 items-baseline gap-1.5">
        <span className="text-[15px] font-bold leading-none">Viral</span>
        <span className="truncate text-meta leading-none text-muted-foreground">운영 콘솔</span>
      </span>
    </span>
  )
}
